"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.addSubscriber = addSubscriber;
exports.removeSubscriber = removeSubscriber;
function addSubscriber(subscribers) {
    return function (component) {
        if (!subscribers.includes(component)) {
            subscribers.push(component);
        }
    };
}

function removeSubscriber(subscribers) {
    return function (component) {
        var index = subscribers.indexOf(component);

        if (~index) {
            subscribers.splice(index, 1);
        }
    };
}


//////////////////
// WEBPACK FOOTER
// ./~/react-tabbordion/dist/module/lib/contextSubscribe.js
// module id = 348
// module chunks = 0